import PropTypes from 'prop-types';
import React from 'react';
import styles from './QuestionDetails.module.css';

const QuestionDetails = ({ question, i18n }) => {
  const content = question.content || '';

  return (
    <div className={styles.description}>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{
          __html: content.replace(/(<br \/>){2,}/g, '<br />'),
        }}
      />
      <div className={styles.actions}>
        <div className={styles.profile}>
          {i18n(
            'page.question.author-profile-template',
            question.profile.displayName
          )}
        </div>
      </div>
    </div>
  );
};

QuestionDetails.propTypes = {
  question: PropTypes.object,
  i18n: PropTypes.func,
  generateUri: PropTypes.func,
};

export default QuestionDetails;
